// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

export const usageListRecords = /* GraphQL */ `
	query UsageListRecords($billingPeriod: String!, $userId: String) {
		usageListRecords(billingPeriod: $billingPeriod, userId: $userId) {
			items {
				id
				userId
				userName
				jobId
				jobType
				timestamp
				billingPeriod
				metricType
				metricValue
				sourceLanguage
				targetLanguageCount
				contentType
				costRateApplied
				estimatedCost
				incomplete
				archived
			}
			nextToken
		}
	}
`;

export const usageListAllRecords = /* GraphQL */ `
	query UsageListAllRecords($billingPeriod: String!, $jobType: String) {
		usageListAllRecords(billingPeriod: $billingPeriod, jobType: $jobType) {
			items {
				id
				userId
				userName
				jobId
				jobType
				timestamp
				billingPeriod
				metricType
				metricValue
				sourceLanguage
				targetLanguageCount
				contentType
				costRateApplied
				estimatedCost
				incomplete
				archived
			}
			nextToken
		}
	}
`;

export const costRateGetCurrent = /* GraphQL */ `
	query CostRateGetCurrent {
		costRateGetCurrent {
			id
			characterCostRate
			effectiveTimestamp
			updatedBy
		}
	}
`;

export const reportScheduleGetConfig = /* GraphQL */ `
	query ReportScheduleGetConfig {
		reportScheduleGetConfig {
			id
			schedule
			format
			recipients
			updatedBy
			updatedAt
		}
	}
`;

export const awsAccountCostGet = /* GraphQL */ `
	query AwsAccountCostGet($billingPeriod: String!) {
		awsAccountCostGet(billingPeriod: $billingPeriod) {
			billingPeriod
			costAmount
			currency
		}
	}
`;
